export function _GET_ROLE(role: string, terminologyDomain?: string) {
	switch (role) {
		case 'leader':
			return 'Giám đốc';
		case 'admin':
			return 'Trưởng chuyên môn';
		case 'org_admin':
			return 'Quản lý cơ sở';
		case 'teacher':
			return _GET_TERMINOLOGY('teacher', terminologyDomain) || 'Trị liệu viên';
		case 'accountant':
			return 'Kế toán';
		case 'support':
			return 'Hỗ trợ';
		default:
			return 'Hỗ trợ';
	}
}

export function _GET_TERMINOLOGY(type: string, terminologyDomain?: string) {
	switch (terminologyDomain) {
		case 'special_education':
			if (type === 'teacher') return 'Trị liệu viên';
			if (type === 'plan') return 'Kế hoạch can thiệp';
			if (type === 'teacher_short_name') return 'TLV';
			return '';
		case 'early_childhood_education':
			if (type === 'teacher') return 'Giáo viên';
			if (type === 'plan') return 'Kế hoạch học';
			if (type === 'teacher_short_name') return 'GV';
			return '';
		default:
			return '';
	}
}
